import NotificationsCenterService from 'src/services/notificationsCenter'

export default {
  resourceRolResponsible (payload) {
    const promise = NotificationsCenterService.resourceRolResponsible(payload)

    return promise
  },
  resourceFetchStatus () {
    const promise = NotificationsCenterService.fetchStatus()

    promise.then(data => {
      this.status = data
    })

    return promise
  },
  fetchResponsibleStatus (payload) {
    const promise = NotificationsCenterService.fetchResponsibleStatus(payload)

    promise.then(data => {
      this.notification = data
    })

    return promise
  },
  updateResponsibleStatus (payload) {
    const promise = NotificationsCenterService.updateResponsibleStatus(payload)

    return promise
  },
  updateFranchisesStatus (payload) {
    const promise = NotificationsCenterService.updateFranchisesStatus(payload)

    return promise
  },
  updateResponsibleEmail (payload) {
    const promise = NotificationsCenterService.updateResponsibleEmail(payload)

    return promise
  }
}
